import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from 'firebase/auth';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB6wSpebMcwz8J5h1Na2lRuAhfg84lmpXc",
    authDomain: "fasiaxamarin.firebaseapp.com",
    databaseURL: "https://fasiaxamarin-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "fasiaxamarin",
    storageBucket: "fasiaxamarin.appspot.com",
    messagingSenderId: "902595841686",
    appId: "1:902595841686:web:3ff36079c628d1a67b3cb7",
    measurementId: "G-K26W93T1XB"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);
const auth = getAuth()

export { database, auth };

  